let offsetMs = Number(localStorage.getItem("serverTimeOffsetMs") || 0);
let offsetAtMs = Number(localStorage.getItem("serverTimeOffsetAtMs") || 0);

const OFFSET_TTL_MS = 10 * 60 * 1000; // 10 phút
const MAX_JUMP_MS = 5 * 60 * 1000;    // chống nhảy offset quá lớn (5 phút)

export function getSyncedTimestampSec() {
  const now = Date.now();
  const useOffset = now - offsetAtMs < OFFSET_TTL_MS ? offsetMs : 0;
  return Math.floor((now + useOffset) / 1000);
}

export function updateOffsetFromResponse(res) {
  const headers = res?.headers || {};

  // ✅ Ưu tiên: X-Server-Time (epoch ms)
  const serverTimeMsRaw = headers["x-server-time"];
  if (serverTimeMsRaw) {
    const serverMs = Number(serverTimeMsRaw);
    if (Number.isFinite(serverMs)) {
      const clientMs = Date.now();
      const newOffset = serverMs - clientMs;

      // lọc nhiễu: nếu nhảy quá lớn thì vẫn cập nhật nhưng bạn có thể cảnh báo/log
      if (Math.abs(newOffset - offsetMs) > MAX_JUMP_MS) {
        console.warn("[timeSync] offset jump(ms):", newOffset - offsetMs);
      }

      offsetMs = newOffset;
      offsetAtMs = clientMs;

      localStorage.setItem("serverTimeOffsetMs", String(offsetMs));
      localStorage.setItem("serverTimeOffsetAtMs", String(offsetAtMs));
      return;
    }
  }

  // ✅ Fallback: Date header (string)
  const dateStr = headers["date"];
  if (!dateStr) return;

  const serverMs = new Date(dateStr).getTime();
  if (!Number.isFinite(serverMs)) return;

  const clientMs = Date.now();
  const newOffset = serverMs - clientMs;

  if (Math.abs(newOffset - offsetMs) > MAX_JUMP_MS) {
    console.warn("[timeSync] offset jump(ms):", newOffset - offsetMs);
  }

  offsetMs = newOffset;
  offsetAtMs = clientMs;

  localStorage.setItem("serverTimeOffsetMs", String(offsetMs));
  localStorage.setItem("serverTimeOffsetAtMs", String(offsetAtMs));
}